import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Stack, Type } from 'react-spark';
import { OffersV2ExpectationsCard } from './OffersV2ExpectationsCard';
import { formatMoney } from '../../../../utils/numbers';

export class OffersV2Header extends Component {
    static defaultProps = {
        firstName: '',
        maxOffer: 0,
        requestedAmountAvailable: false
    };

    static propTypes = {
        firstName: PropTypes.string.isRequired,
        maxOffer: PropTypes.number.isRequired,
        requestedAmountAvailable: PropTypes.bool.isRequired,
        customizedOffer: PropTypes.number
    };

    render() {
        const { firstName, maxOffer, requestedAmountAvailable, customizedOffer } = this.props;
        const offerAmount = customizedOffer || maxOffer;

        return (
            <Stack splitAt="medium" className="sprk-u-ptl@m sprk-u-pbm@m" style={{ gap: '24px' }}>
                <Stack.Item className="sprk-u-man" style={{ flex: 'auto' }}>
                    <Type.DisplayTwo className="antialiased sprk-u-pbl sprk-u-man" style={{ lineHeight: 1.2 }}>
                        { requestedAmountAvailable ? (
                            <Fragment>
                                Congrats {firstName}! <br /> 
                                You&rsquo;re prequalified for{' '}
                                {formatMoney(Math.floor(offerAmount), true)}.
                                <sup className="superscript">*</sup> 
                            </Fragment>
                        ) : (
                            <Fragment>
                                Good news {firstName}! <br />
                                You&rsquo;re prequalified for a loan up to{' '}
                                {formatMoney(Math.floor(maxOffer), true)}.
                                <sup className="superscript">*</sup> 
                            </Fragment>
                        )}
                    </Type.DisplayTwo>

                    <Type.DisplaySix className="antialiased sprk-u-pbm">
                        { requestedAmountAvailable ? (
                            <Fragment>
                                Select an offer or choose another amount to see more offers you're prequalified for.
                            </Fragment>
                        ) : (
                            <Fragment>
                                Here are your top offers based on your application.
                            </Fragment>
                        )}    
                    </Type.DisplaySix>

                    <Type.BodyFour className="antialiased">
                        Your loan offers are valid for 5 days. After 5 days you will need to resubmit your information.
                    </Type.BodyFour>
                </Stack.Item>
                <Stack.Item className="sprk-u-man sprk-o-Stack__item--two-fifths@xs sprk-u-Display--none sprk-u-Display--block@m">
                    <OffersV2ExpectationsCard
                        contentTop={(
                            <Type.DisplayFive className="sprk-u-pvm sprk-u-man">
                                What to expect with your loan:
                            </Type.DisplayFive>
                        )}
                        className="sprk-u-pam sprk-u-BackgroundColor--gray sprk-u-BorderSolid sprk-u-Border--1 sprk-u-BorderColor--black"
                    />
                </Stack.Item>
            </Stack>
        );
    }
}
